import Vue from '@/setup'
import Vuex from 'vuex'

import BasketModule from '@/store/modules/Basket'
import ContentModule from '@/store/modules/Content'
import ContractModule from '@/store/modules/Contract'
import ProductModule from '@/store/modules/Product'

import survey from 'sanitas-survey-vue2/src/store/survey'

Vue.use(Vuex)

const DEV_MODE = process.env.NODE_ENV === 'development' || window.location.hash.indexOf('devmode=1')

if (!window.Vuex) {
  window.Vuex = new Vuex.Store({
    state: {
      shouldValidate: false,
    },
    getters: {},
    mutations: {
      SET_VALIDATION(state, value) {
        state.shouldValidate = value
      },
    },
    actions: {
      turnOffValidation({ _state, commit }) {
        commit('SET_VALIDATION', false)
      },
      turnOnValidation({ _state, commit }) {
        commit('SET_VALIDATION', true)
      },
    },
    modules: {
      basket: BasketModule,
      content: ContentModule,
      contract: ContractModule,
      products: ProductModule,
      survey,
    },
    strict: DEV_MODE,
  })
}

export default window.Vuex
